import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import agent from "../../agent";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Heading from "../../components/Heading";
import BookingRequests from "../../components/booking/BookingRequests";
import BookingAccepted from "../../components/booking/BookingAccepted";
import BookingCompleted from "../../components/booking/BookingCompleted";
import BookingCancelled from "../../components/booking/BookingCancelled";
import BookingDrafts from "../../components/booking/BookingDrafts";
import BookingAll from "../../components/booking/BookingAll";
import { Tabs, Tab, Badge, Hidden, TextField, MenuItem, Grid, Typography, IconButton } from "@material-ui/core";
import Loading from "../../components/loadingSpinner/Loading";
import WidgetContainer from "../../components/widget/WidgetContainer";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import DirectionsIcon from "@material-ui/icons/Directions";
import PhoneIcon from "@material-ui/icons/Phone";
import VisibilityIcon from "@material-ui/icons/Visibility";
import moment from "moment";
import { ProfileType } from "../../types/enum";
import jwtDecode from "jwt-decode";
import "./MusicianBookings.css";
import "./MySchedule.css";
import ScheduleDateToolbar from "../../components/filters/ScheduleDateToolbar";
import { scheduleRange, navigateScheduleDate, customRangeError } from "./scheduleDateRange";
import FacebookSharePostDialog from "../../components/facebookSharePostDialog/FacebookSharePostDialog";
import Button from "@material-ui/core/Button";
import bookingCalculationHelper from "../../helper/bookingCalculationHelper";
import MyScheduleAnnouncementModal from "../../components/modal/MyScheduleAnnouncementModal";

const ENABLE_SUBSCRIPTION = process.env.REACT_APP_ENABLE_SUBSCRIPTION === "true";

const styles = theme => ({
    root: {
        width: "90%"
    },
    backButton: {
        marginRight: theme.spacing.unit
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    }
});

@inject("templateStore", "profileStore", "bookingRequestStore", "reportStore", "commonStore")
@withRouter
@observer
class MySchedule extends Component {
    state = {
        tabValue: 2,
        dashboardData: {},
        todaysGigs: [],
        todayGigIndex: 0,
        isLoadingDashboard: true,
        startDate: null,
        endDate: null,
        selectedFilter: "month",
        anchorDate: moment().startOf("day"),
        customStart: null,
        customEnd: null,
        dashboardError: "",
        gigsError: "",
        showAnnouncementModal: false
    };

    currentUserId = 0;
    hasLoadedRequestGigs = false;
    requestGigsLoadPromise = null;
    scheduleIsMounted = false;
    dateRequestVersion = 0;
    listRequestVersion = 0;
    dashboardRequestVersion = 0;

    createScheduleDateGuard = () => {
        const dateVersion = this.dateRequestVersion;
        const listVersion = this.listRequestVersion;
        const profileId = this.currentUserId;
        return () => this.scheduleIsMounted &&
            dateVersion === this.dateRequestVersion &&
            listVersion === this.listRequestVersion &&
            profileId === this.props.profileStore.currentProfile?.id;
    };

    constructor(props) {
        super(props);
        this.props.bookingRequestStore.resetRequestGigs();
        this.props.bookingRequestStore.resetRequestsUpcomingCompleted();
        this.props.reportStore.resetFilterData();
    }

    formatDate = date => {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    };

    componentWillUnmount() {
        this.scheduleIsMounted = false;
        if (this.props.bookingRequestStore.scheduleDateRequestGuard === this.createScheduleDateGuard)
            this.props.bookingRequestStore.scheduleDateRequestGuard = null;
        this.props.reportStore.resetFilterData();
    }

    componentDidMount = () => {
        const { currentProfile } = this.props.profileStore;
        this.currentUserId = currentProfile?.id;
        this.scheduleIsMounted = true;
        this.props.bookingRequestStore.scheduleDateRequestGuard = this.createScheduleDateGuard;

        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        
        let startMoment = moment(firstDay).startOf("day");
        let endMoment = moment(lastDay).endOf("day");
        
        this.props.reportStore.setStartDate(startMoment);
        this.props.reportStore.setEndDate(endMoment);
        
        this.setState({ startDate: startMoment, endDate: endMoment, customStart: startMoment.clone(), customEnd: endMoment.clone() });

        this.handleDashboardLoad(this.currentUserId, this.formatDate(firstDay) + " 00:00:00", this.formatDate(lastDay) + " 23:59:59.999");

        let initialTab = 2;
        if (this.props && this.props.match && this.props.match.params && this.props.match.params.tab) {
            const tab = this.props.match.params.tab;
            if (tab === "drafts") {
                initialTab = 0;
            } else if (tab === "request") {
                initialTab = 1;
            } else if (tab === "upcoming" || tab === "upcomingSuper") {
                initialTab = 2;
            } else if (tab === "completed") {
                initialTab = 3;
            } else if (tab === "cancelled") {
                initialTab = 4;
            } else if (tab === "all") {
                initialTab = 5;
            }
            this.setState({ tabValue: initialTab });
        }

        this.reloadGigsForCurrentTab(initialTab);

        if (currentProfile?.type === ProfileType.Musician.ordinal) {
            if (!currentProfile.hasSeenScheduleIntro) {
                this.setState({ showAnnouncementModal: true });
            }
        }
    };

    handleDismissAnnouncement = async () => {
        const { profileStore } = this.props;
        const currentProfile = profileStore.getCurrentProfile();
        
        try {
            await agent.Profile.setHasSeenScheduleIntro(currentProfile.id);
            profileStore.setHasSeenScheduleIntro(true);
        } catch (error) {
            console.error("Failed to update schedule intro status:", error);
        }
        this.setState({ showAnnouncementModal: false });
    };

    handleDashboardLoad = (id, start, end) => {
        const requestVersion = ++this.dashboardRequestVersion;
        const isCurrent = () => this.scheduleIsMounted &&
            requestVersion === this.dashboardRequestVersion &&
            id === this.props.profileStore.currentProfile?.id;
        return Promise.all([
            agent.Profile.getMusicianDashboardMain(id, start, end),
            agent.Profile.getMusicianDashboardRequests(id, start, end),
            agent.Booking.loadCompletedGigs(id, start, end, undefined, undefined, undefined, undefined, undefined, 1, undefined, undefined)
        ]).then(result => {
            if (!isCurrent()) return;
            var contain = result[0];
            contain.newGigAlerts = result[1];
            contain.completedBookings = result[2]?.bookings || [];
            var todayGigs = [];
            contain?.upcomingBookings?.forEach((gig) => {
                var dateStart = moment(gig.dateStart).clone();
                var dateEnd = moment(gig.dateEnd).clone();
                var adjustedDateStart = dateStart.subtract((parseFloat(gig.utcOffset) + dateStart.utcOffset()), 'minute');
                var adjustedDateEnd = dateEnd.subtract(parseFloat(gig.utcOffset) + dateEnd.utcOffset(), 'minute');

                var dstVariable = 120;
                var dstChecking = moment(adjustedDateStart).set({ hour: 2, minute: 0, second: 0, millisecond: 0 });
                if (dstChecking.isAfter(adjustedDateStart)) {
                    adjustedDateStart = adjustedDateStart.clone().subtract(dstVariable, "minute");
                    adjustedDateEnd = adjustedDateEnd.clone().subtract(dstVariable, "minute");
                }
                var iscurrentDate = adjustedDateStart.isSame(new Date(), "day");

                if (iscurrentDate) {
                    todayGigs.push({
                        ...gig,
                        dateStart: adjustedDateStart,
                        dateEnd: adjustedDateEnd
                    });
                }
            });
            this.setState({ dashboardData: contain, todaysGigs: todayGigs, isLoadingDashboard: false });
        }).catch(() => {
            if (isCurrent()) this.setState({ isLoadingDashboard: false, dashboardError: "Could not load the schedule summary. Please retry." });
        });
    };

    handleDashboardFilterChange = value => {
        if (value === "custom") {
            this.setState(prev => ({
                selectedFilter: value,
                customStart: prev.startDate?.clone() || null,
                customEnd: prev.endDate?.clone() || null
            }));
            return;
        }
        this.setState(prev => ({
            selectedFilter: value,
            ...scheduleRange(value, prev.anchorDate)
        }), this.refreshScheduleRange);
    };

    handleNavigatePeriod = direction => {
        this.setState(prev => {
            const anchorDate = navigateScheduleDate(prev.selectedFilter, prev.anchorDate, direction);
            return { anchorDate, ...scheduleRange(prev.selectedFilter, anchorDate) };
        }, this.refreshScheduleRange);
    };

    handleAnchorChange = value => {
        if (!value || !moment(value).isValid()) return;
        this.setState(prev => ({
            anchorDate: moment(value).clone(),
            ...scheduleRange(prev.selectedFilter, value)
        }), this.refreshScheduleRange);
    };

    handleReturnToCurrent = (mode = this.state.selectedFilter) => {
        const anchorDate = moment();
        this.setState({
            selectedFilter: mode,
            anchorDate,
            ...scheduleRange(mode, anchorDate)
        }, this.refreshScheduleRange);
    };

    refreshScheduleRange = () => {
        const { startDate, endDate } = this.state;
        this.dateRequestVersion += 1;
        this.props.reportStore.setStartDate(startDate.clone());
        this.props.reportStore.setEndDate(endDate.clone());
        this.props.bookingRequestStore.resetDateFilteredTabData();
        this.setState({ isLoadingDashboard: true, dashboardError: "", gigsError: "", dashboardData: {}, todaysGigs: [] });
        this.handleDashboardLoad(this.currentUserId, startDate.format("YYYY-MM-DD HH:mm:ss.SSS"), endDate.format("YYYY-MM-DD HH:mm:ss.SSS"));
        this.reloadGigsForCurrentTab();
    };
    
    loadRequestGigs = (forceReload = false) => {
        const { currentProfile } = this.props.profileStore;

        if (!forceReload && this.hasLoadedRequestGigs) {
            return Promise.resolve();
        }

        if (this.requestGigsLoadPromise) {
            return this.requestGigsLoadPromise;
        }

        this.props.bookingRequestStore.showLoadingState();
        this.props.bookingRequestStore.resetRequestGigs();
        const isCurrent = this.createScheduleDateGuard();

        this.requestGigsLoadPromise = this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id, 1)
            .then(result => {
                this.hasLoadedRequestGigs = true;
                return result;
            })
            .finally(() => {
                this.requestGigsLoadPromise = null;
                if (isCurrent()) this.props.bookingRequestStore.hideLoadingState();
            });

        return this.requestGigsLoadPromise;
    };

    reloadGigsForCurrentTab = (tabOverride) => {
        const { currentProfile } = this.props.profileStore;
        const tabValue = tabOverride !== undefined ? tabOverride : this.state.tabValue;
        this.listRequestVersion += 1;
        const isCurrent = this.createScheduleDateGuard();
        const store = this.props.bookingRequestStore;
        let request;
        if (tabValue === 0 || tabValue === 1) {
            request = this.loadRequestGigs();
        } else if (tabValue === 2) {
            store.resetUpcomingGigs();
            request = store.loadUpcomingGigs(currentProfile?.id, 1);
        } else if (tabValue === 3) {
            store.resetCompletedGigs();
            request = store.getCompletedGigs(currentProfile?.id, 1);
        } else if (tabValue === 4) {
            store.resetCancelledGigs();
            request = store.getCancelledGigs(currentProfile?.id, 1);
        } else if (tabValue === 5) {
            store.resetAllGigs();
            request = store.loadAllGigs(currentProfile?.id, 1);
        }
        store.showLoadingState();
        return Promise.resolve(request).catch(() => {
            if (isCurrent()) this.setState({ gigsError: "Could not load gigs for this range. Please retry." });
        }).finally(() => {
            if (isCurrent()) store.hideLoadingState();
        });
    };

    handleDayOfWeekChange = (e) => {
        const value = e === null ? null : Number(e);
        this.props.reportStore.setDayOfWeekFilter(value);
        this.reloadGigsForCurrentTab();
    };

    renderDateFilterButtons = () => {
        const { selectedFilter, anchorDate, startDate, endDate, customStart, customEnd, isLoadingDashboard } = this.state;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const isMusicianProfile = currentProfile?.type === ProfileType.Musician.ordinal;
        const { dayOfWeekFilter } = this.props.reportStore;
        const error = customRangeError(customStart, customEnd);
        return (
            <ScheduleDateToolbar
                mode={selectedFilter}
                anchorDate={anchorDate}
                startDate={startDate}
                endDate={endDate}
                customStart={customStart}
                customEnd={customEnd}
                onModeChange={this.handleDashboardFilterChange}
                onNavigate={this.handleNavigatePeriod}
                onAnchorChange={this.handleAnchorChange}
                onReturnToCurrent={this.handleReturnToCurrent}
                onCustomStartChange={this.onCustomStartDateChange}
                onCustomEndChange={this.onCustomEndDateChange}
                onApplyCustom={this.applyCustomRange}
                customError={error}
                canApplyCustom={!error}
                dayOfWeek={dayOfWeekFilter}
                onDayOfWeekChange={this.handleDayOfWeekChange}
                showDayFilter={!isMusicianProfile}
                loading={isLoadingDashboard || this.props.bookingRequestStore.isLoading}
            />
        );
    };
    onCustomStartDateChange = value => this.setState({ customStart: value ? moment(value).clone() : null });
    onCustomEndDateChange = value => this.setState({ customEnd: value ? moment(value).clone() : null });

    applyCustomRange = () => {
        const { customStart, customEnd } = this.state;
        if (customRangeError(customStart, customEnd)) return;
        this.setState({
            anchorDate: moment(customStart).clone(),
            startDate: moment(customStart).startOf("day"),
            endDate: moment(customEnd).endOf("day")
        }, this.refreshScheduleRange);
    };

    loadGigs = () => {
        this.loadRequestGigs(true);
        this.reloadGigsForCurrentTab();
    };

    handleTabChange = (event, value) => {
        switch (value) {
            case 0:
                this.props.history.replace("/musician/schedule/drafts");
                break;
            case 1:
                this.props.history.replace("/musician/schedule/request");
                break;
            case 2:
                this.props.history.replace("/musician/schedule/upcoming");
                break;
            case 3:
                this.props.history.replace("/musician/schedule/completed");
                break;
            case 4:
                this.props.history.replace("/musician/schedule/cancelled");
                break;
            case 5:
                this.props.history.replace("/musician/schedule/all");
                break;
            default:
                this.props.history.replace("/musician/schedule/upcoming");
                break;
        }

        this.setState({ tabValue: value });
        this.reloadGigsForCurrentTab(value);
    };

    handleSelectChange = event => {
        this.handleTabChange(null, event.target.value);
    };

    renderTabComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <BookingDrafts profileType="musician" />;
            case 1:
                return <BookingRequests profileType="musician" />;
            case 2:
                return <BookingAccepted profileType="musician" />;
            case 3:
                return <BookingCompleted profileType="musician" />;
            case 4:
                return <BookingCancelled profileType="musician" />;
            case 5:
                return <BookingAll profileType="musician" />;
            default:
                return "";
        }
    };

    renderTabTitle = (title, list) => {
        return list && list.length > 0 ? (
            <Badge color="primary" style={{ paddingRight: "16px" }} badgeContent={list ? list.length : 0}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    renderTabTitleSmall = (title, list) => {
        let content = <span className="test">{list ? list.length : 0}</span>;
        return list && list.length > 0 ? (
            <Badge color="primary" classes={{ badge: "itembadge" }} badgeContent={content}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    onNextTodayGig = () => {
        if (this.state.todaysGigs && this.state.todaysGigs.length > 0) {
            if (this.state.todayGigIndex + 1 === this.state.todaysGigs.length) {
                this.setState({ todayGigIndex: 0 });
            } else {
                this.setState({ todayGigIndex: this.state.todayGigIndex + 1 });
            }
        }
    };

    onPreviousTodayGig = () => {
        if (this.state.todaysGigs && this.state.todaysGigs.length > 0) {
            if (this.state.todayGigIndex - 1 < 0) {
                this.setState({ todayGigIndex: this.state.todaysGigs.length - 1 });
            } else {
                this.setState({ todayGigIndex: this.state.todayGigIndex - 1 });
            }
        }
    };

    getDirectionsUrl = (address) => {
        if (!address) return "#";
        const encodedAddress = encodeURIComponent(address);
        return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
    };

    handleViewBookingDetails = (bookingId) => {
        this.props.history.push(`/musician/booking/${bookingId}/details`);
    };

    renderTodaysGigsWidget = () => {
        const { todaysGigs, todayGigIndex } = this.state;
        const { currentProfile } = this.props.profileStore;

        if (!todaysGigs || todaysGigs.length === 0) {
            return (
                <Paper className="schedule-todays-gigs-widget">
                    <div className="schedule-widget-header">
                        <div className="schedule-widget-title">
                            <i className="fa fa-calendar-day schedule-widget-icon"></i>
                            Today's Gigs
                        </div>
                    </div>
                    <div className="schedule-no-gigs">
                        <i className="fa fa-search schedule-no-gigs-icon"></i>
                        <div className="schedule-no-gigs-text">No gigs for today.</div>
                        <div className="schedule-no-gigs-subtext">Use the search functionality to connect with agents and venues</div>
                    </div>
                </Paper>
            );
        }

        const gig = todaysGigs[todayGigIndex];
        const startTime = moment(gig.timeStart, "HH:mm:ss").format(this.props.templateStore.getFormat12Hour(gig.timeStart));
        const endTime = moment(gig.timeEnd, "HH:mm:ss").format(this.props.templateStore.getFormat12Hour(gig.timeEnd));
        const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && gig.createdById === currentProfile?.id && !gig.act?.actName;
        const actName = isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : gig.act?.actName;
        let lineup = gig.lineups?.find(x => x.profileId === currentProfile?.id);
        let myFee = lineup?.fee ? lineup?.fee : parseFloat(gig.actFee) ? gig.actFee : gig.gigFee;
        const currencySymbol = currentProfile?.currencySymbol || "$";

        return (
            <Paper className="schedule-todays-gigs-widget">
                <div className="schedule-widget-header">
                    <div className="schedule-widget-title">
                        <i className="fa fa-calendar-day schedule-widget-icon"></i>
                        Today's Gigs
                        <span className="schedule-gig-count-badge">{todaysGigs.length}</span>
                    </div>
                    {todaysGigs.length > 1 && (
                        <div className="schedule-widget-nav">
                            <IconButton onClick={this.onPreviousTodayGig} size="small" className="schedule-nav-btn">
                                <KeyboardArrowLeftIcon />
                            </IconButton>
                            <IconButton onClick={this.onNextTodayGig} size="small" className="schedule-nav-btn">
                                <KeyboardArrowRightIcon />
                            </IconButton>
                        </div>
                    )}
                </div>
                <div className="schedule-gig-card">
                    <div className="schedule-gig-venue-name">{gig.venueName}</div>
                    <div className="schedule-gig-act-name">Playing as: {actName}</div>

                    <div className="schedule-gig-details">
                        <div className="schedule-gig-detail-item">
                            <i className="fa fa-clock schedule-detail-icon"></i>
                            <div className="schedule-detail-content">
                                <div className="schedule-detail-label">Playing Times</div>
                                <div className="schedule-detail-value">{startTime} - {endTime}</div>
                            </div>
                        </div>
                        <div className="schedule-gig-detail-item">
                            <i className="fa fa-map-marker-alt schedule-detail-icon"></i>
                            <div className="schedule-detail-content">
                                <div className="schedule-detail-label">Venue Address</div>
                                <div className="schedule-detail-value">{gig.venueAddress || "No address provided"}</div>
                            </div>
                        </div>
                        <div className="schedule-gig-detail-item">
                            <i className="fa fa-user schedule-detail-icon"></i>
                            <div className="schedule-detail-content">
                                <div className="schedule-detail-label">Venue Contact</div>
                                <div className="schedule-detail-value">{gig.venue?.contactName || "N/A"}</div>
                                {gig.venue?.contactPhone && (
                                    <div className="schedule-detail-sub">{gig.venue?.contactPhone}</div>
                                )}
                            </div>
                        </div>
                        <div className="schedule-gig-detail-item">
                            <i className="fa fa-dollar-sign schedule-detail-icon"></i>
                            <div className="schedule-detail-content">
                                <div className="schedule-detail-label">Fee</div>
                                <div className="schedule-detail-value">{currencySymbol}{parseFloat(myFee).toLocaleString()}</div>
                            </div>
                        </div>
                    </div>

                    <div className="schedule-gig-actions">
                        <a
                            href={this.getDirectionsUrl(gig.venueAddress)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="schedule-action-btn schedule-action-btn-primary"
                        >
                            <DirectionsIcon fontSize="small" />
                            Get Directions
                        </a>
                        <button
                            className="schedule-action-btn schedule-action-btn-secondary"
                            onClick={() => this.handleViewBookingDetails(gig.id)}
                        >
                            <VisibilityIcon fontSize="small" />
                            View Details
                        </button>
                        {gig.venue?.contactPhone && (
                            <a
                                href={`tel:${gig.venue?.contactPhone}`}
                                className="schedule-action-btn schedule-action-btn-secondary"
                            >
                                <PhoneIcon fontSize="small" />
                                Call Venue
                            </a>
                        )}
                    </div>
                </div>
            </Paper>
        );
    };

    calculateTotalIncome = () => {
        const { dashboardData } = this.state;
        const { currentProfile } = this.props.profileStore;
        
        let totalIncome = 0;
        
        if (dashboardData.upcomingBookings && Array.isArray(dashboardData.upcomingBookings)) {
            dashboardData.upcomingBookings.forEach(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                totalIncome += parseFloat(collectedFee.feePaidToActNumber) || 0;
            });
        }
        
        if (dashboardData.completedBookings && Array.isArray(dashboardData.completedBookings)) {
            dashboardData.completedBookings.forEach(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                totalIncome += parseFloat(collectedFee.feePaidToActNumber) || 0;
            });
        }
        
        return totalIncome;
    };

    renderIncomeWidget = () => {
        const { dashboardData, startDate, endDate } = this.state;
        const { currentProfile } = this.props.profileStore;
        const currencySymbol = currentProfile?.currencySymbol || "$";

        var decoded = null;
        if (this.props.commonStore.token) {
            decoded = jwtDecode(this.props.commonStore.token);
        }

        const taxCode = currentProfile && currentProfile.tax && currentProfile.tax !== "CUSTOM" ? currentProfile.tax : "GST";
        const taxText = currentProfile?.taxValue && parseInt(currentProfile?.taxValue) > 0 ? ` (EX ${taxCode})` : "";

        const showIncome = !ENABLE_SUBSCRIPTION || (decoded && decoded.scope && decoded.scope.includes(currentProfile?.typeString));

        const calculatedIncome = this.calculateTotalIncome();
        
        const getDateRangeLabel = () => {
            if (!startDate || !endDate) return moment().format("MMMM YYYY");
            const start = moment(startDate);
            const end = moment(endDate);
            if (start.isSame(end, 'day')) {
                return start.format("DD MMM YYYY");
            } else if (this.state.selectedFilter === "month") {
                return start.format("MMMM YYYY");
            } else {
                return `${start.format("DD MMM")} - ${end.format("DD MMM YYYY")}`;
            }
        };

        return (
            <Paper className="schedule-income-widget">
                <div className="schedule-income-label">MY INCOME{taxText}</div>
                <div className="schedule-income-amount">
                    {showIncome ? (
                        `${currencySymbol}${calculatedIncome.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    ) : (
                        <span className="schedule-income-locked">Subscribe to view</span>
                    )}
                </div>
                <div className="schedule-income-month">{getDateRangeLabel()}</div>
                <div className="schedule-income-breakdown">
                    <div className="schedule-breakdown-item">
                        <div className="schedule-breakdown-value">{dashboardData.totalGigs !== undefined ? dashboardData.totalGigs : "-"}</div>
                        <div className="schedule-breakdown-label">Total Gigs</div>
                    </div>
                    <div className="schedule-breakdown-item">
                        <div className="schedule-breakdown-value">{dashboardData.upcomingGigs !== undefined ? dashboardData.upcomingGigs : "-"}</div>
                        <div className="schedule-breakdown-label">Upcoming</div>
                    </div>
                    <div className="schedule-breakdown-item">
                        <div className="schedule-breakdown-value">{dashboardData.completedGigs !== undefined ? dashboardData.completedGigs : "-"}</div>
                        <div className="schedule-breakdown-label">Completed</div>
                    </div>
                </div>
            </Paper>
        );
    };

    render() {
        let { requests, upcomings, cancelled, completed, drafts, newRequests, isLoading: isLoadingGigs, allGigs } = this.props.bookingRequestStore;
        const { isLoadingDashboard, tabValue } = this.state;

        return (
            <div className="my-schedule-page">
                <Header />
                <Sidebar />
                <MainContainer>
                    <div className="my-schedule-date-heading">
                        <Heading title="My Schedule">
                            {this.renderDateFilterButtons()}
                        </Heading>
                    </div>
                    {(this.state.dashboardError || this.state.gigsError) && (
                        <div role="alert" className="schedule-filter-error">
                            {this.state.dashboardError || this.state.gigsError}
                            <Button onClick={this.refreshScheduleRange} color="primary">Retry</Button>
                        </div>
                    )}

                    <div className="schedule-summary-section" style={{ position: "relative" }}>
                        <Loading showed={isLoadingDashboard} />
                        <Grid container spacing={16}>
                            <Grid item xs={12} md={4}>
                                {this.renderIncomeWidget()}
                            </Grid>
                            <Grid item xs={12} md={8}>
                                {this.renderTodaysGigsWidget()}
                            </Grid>
                        </Grid>
                    </div>

                    <Paper style={{ position: "relative", marginTop: 24 }} className="booking-paper-form">
                        <Loading showed={isLoadingGigs} />
                        <div style={{ padding: 16 }}>
                            <div className="schedule-gigs-header">
                                <Typography variant="h6" className="schedule-gigs-title">My Gigs</Typography>
                            </div>
                            <Hidden smDown>
                                <Tabs
                                    value={tabValue}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    scrollable
                                    scrollButtons="off"
                                >
                                    <Tab label={this.renderTabTitle("Draft Bookings", drafts)} />
                                    <Tab label={this.renderTabTitle("Booking Requests", newRequests)} />
                                    <Tab label={this.renderTabTitle("Upcoming Gigs", upcomings)} />
                                    <Tab label={this.renderTabTitle("Completed Gigs", completed)} />
                                    <Tab label={this.renderTabTitle("Cancelled Gigs", cancelled)} />
                                    <Tab label={this.renderTabTitle("All Gigs", allGigs)} />
                                </Tabs>
                                <br />
                            </Hidden>
                            <Hidden mdUp>
                                <TextField
                                    select
                                    value={tabValue}
                                    onChange={this.handleSelectChange}
                                    textColor="primary"
                                    style={{ marginBottom: 20 }}
                                    fullWidth
                                >
                                    <MenuItem key={0} value={0}>
                                        {this.renderTabTitleSmall("Draft Bookings", drafts)}
                                    </MenuItem>
                                    <MenuItem key={1} value={1}>
                                        {this.renderTabTitleSmall("Booking Requests", requests)}
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        {this.renderTabTitleSmall("Upcoming Gigs", upcomings)}
                                    </MenuItem>
                                    <MenuItem key={3} value={3}>
                                        {this.renderTabTitleSmall("Completed Gigs", completed)}
                                    </MenuItem>
                                    <MenuItem key={4} value={4}>
                                        {this.renderTabTitleSmall("Cancelled Gigs", cancelled)}
                                    </MenuItem>
                                    <MenuItem key={5} value={5}>
                                        {this.renderTabTitleSmall("All Gigs", allGigs)}
                                    </MenuItem>
                                </TextField>
                            </Hidden>
                            {this.renderTabComponent()}
                        </div>
                    </Paper>
                </MainContainer>
                <FacebookSharePostDialog profileType="musician" />
                <MyScheduleAnnouncementModal
                    open={this.state.showAnnouncementModal}
                    onDismiss={this.handleDismissAnnouncement}
                />
            </div>
        );
    }
}

MySchedule.propTypes = {
    classes: PropTypes.object
};

export default withStyles(styles)(MySchedule);
